var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.75 12.5C14.75 14.2949 13.2949 15.75 11.5 15.75C9.70507 15.75 8.25 14.2949 8.25 12.5C8.25 10.7051 9.70507 9.25 11.5 9.25C13.2949 9.25 14.75 10.7051 14.75 12.5ZM11.5 14.75C12.7426 14.75 13.75 13.7426 13.75 12.5C13.75 11.2574 12.7426 10.25 11.5 10.25C10.2574 10.25 9.25 11.2574 9.25 12.5C9.25 13.7426 10.2574 14.75 11.5 14.75Z",
    fill: "#000624"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 6C17.293 6 19.813 12.041 19.918 12.298L20 12.5L19.918 12.701C19.813 12.959 17.293 19 11.5 19C5.707 19 3.187 12.959 3.082 12.701L3 12.5L3.082 12.298C3.187 12.041 5.707 6 11.5 6ZM11.5 7.036C6.92 7.036 4.565 11.488 4.089 12.499C4.567 13.51 6.932 17.964 11.5 17.964C16.08 17.964 18.435 13.512 18.911 12.5C18.433 11.49 16.068 7.036 11.5 7.036Z",
    fill: "#000624"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.fb4f7a858058f2f889203f5003ad1133.svg";
export { ForwardRef as ReactComponent };